module.exports = __webpack_public_path__ + "img/grabar.8b32cd08.svg";